/**
 * Magicstar Theme — Hero Carousel JS
 */
(function () {
  'use strict';

  var track = document.getElementById('heroTrack');
  if (!track) return;

  var slides = track.querySelectorAll('.hero-carousel__slide');
  var dots = document.querySelectorAll('.hero-carousel__dot');
  var prevBtn = document.querySelector('.hero-carousel__btn--prev');
  var nextBtn = document.querySelector('.hero-carousel__btn--next');

  if (slides.length <= 1) return;

  var current = 0;
  var total = slides.length;
  var autoplay = track.getAttribute('data-autoplay') !== 'false';
  var interval = parseInt(track.getAttribute('data-interval'), 10) || 5000;
  var timer;

  function goTo(idx) {
    slides[current].classList.remove('is-active');
    dots[current] && dots[current].classList.remove('is-active');
    dots[current] && dots[current].setAttribute('aria-selected', 'false');

    current = (idx + total) % total;

    slides[current].classList.add('is-active');
    dots[current] && dots[current].classList.add('is-active');
    dots[current] && dots[current].setAttribute('aria-selected', 'true');
  }

  function startAutoplay() {
    if (!autoplay) return;
    timer = setInterval(function () { goTo(current + 1); }, interval);
  }

  function stopAutoplay() { clearInterval(timer); }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      stopAutoplay();
      goTo(current - 1);
      startAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      stopAutoplay();
      goTo(current + 1);
      startAutoplay();
    });
  }

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      stopAutoplay();
      goTo(i);
      startAutoplay();
    });
  });

  // Touch support
  var touchStartX = 0;
  track.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });
  track.addEventListener('touchend', function (e) {
    var diff = touchStartX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 50) {
      stopAutoplay();
      goTo(diff > 0 ? current + 1 : current - 1);
      startAutoplay();
    }
  }, { passive: true });

  // Pause on hover/focus
  track.addEventListener('mouseenter', stopAutoplay);
  track.addEventListener('mouseleave', startAutoplay);
  track.addEventListener('focusin', stopAutoplay);
  track.addEventListener('focusout', startAutoplay);

  // Pause when tab is hidden (reduces CPU, prevents invisible events)
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopAutoplay(); else startAutoplay();
  });

  startAutoplay();
}());
